module.exports = __webpack_public_path__ + "e30fded59bc8845d16873d622c5560b9.png";